import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getExpiringProducts} from "../../../redux/slice/product-slice";
import ProductsTable from "./components/products-table";
import SearchComponent from "./components/search-component";

const ProductExpiringPage = () =>{

    const diaptch = useDispatch();

    useEffect(()=>{
        diaptch(getExpiringProducts())
    },[])

    return(
        <>
        <SearchComponent/>
        <ProductsTable/>
        </>
    )
}

export default ProductExpiringPage;